export default function normalizeRAG(value: string): number | null {
    let res = null

    if (value) {
        if (value.toString().toLowerCase()==='red')         res = 0
        else if (value.toString().toLowerCase()==='amber')  res = 1
        else if (value.toString().toLowerCase()==='green')  res = 2
        else {
            res = parseInt(value)
            if (isNaN(res)) res = null
        }
    }

    return res
}